import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_NOTIFICATIONS_PERMISSIONS,
  SETTINGS_NOTIFICATIONS_LIST_QUERY_KEY,
  SETTINGS_NOTIFICATIONS_LIST_URL,
} from '@modules/general-settings/submodules/notifications/constants';

import type {
  ISettingsNotificationsPayload,
  ISettingsNotificationsResponse,
} from '../types';

export default function useSettingsNotificationsListQuery(payload: Ref<ISettingsNotificationsPayload>): IContextQueryResult<ISettingsNotificationsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsNotificationsResponse, Error>({
    queryKey: [SETTINGS_NOTIFICATIONS_LIST_QUERY_KEY, payload],
    queryFn: ({ signal }) => fetchGet<ISettingsNotificationsResponse>(SETTINGS_NOTIFICATIONS_LIST_URL, {
      signal,
      queryParams: payload.value,
      permission: ADMIN_GENERAL_SETTINGS_NOTIFICATIONS_PERMISSIONS.NOTIFICATIONS_SHOW,
    }),
    enabled: computed(() => !!payload.value?.namespace),
  });
}
